import Vue from 'vue'
import VueMeta from 'vue-meta'
import store from './Store/store'
import PortalVue from 'portal-vue'
import {App, plugin} from '@inertiajs/inertia-vue'
import {InertiaProgress} from '@inertiajs/progress/src'
//Modal imports https://github.com/protonemedia/inertia-vue-modal-poc
import {Modalable, ToModal} from '@protonemedia/inertia-vue-modal-poc'
import {Inertia} from '@inertiajs/inertia'
//Calendar imports
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
// import VCalendar from 'v-calendar'
import { setupCalendar} from 'v-calendar'
//Wizard imports
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

// custom screen voor v-calendar werkt niet
// setupCalendar({
//   screens: {
//     desktop: '1340px',
//   },
// })

Vue.use(VueFormWizard)
//Moment imports
import moment from 'moment'
import i18n from './i18n/i18n'

//Vue Tour imports
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

//v-tooltip imports
import VTooltip from 'v-tooltip'

Vue.use(VTooltip, {defaultBoundariesElement: document.body})

//Modal components
Vue.component('Modalable', Modalable)
Vue.component('ToModal', ToModal)
Vue.use(PortalVue)

Vue.prototype.$bus = new Vue()

//Calendar components
Vue.component('Calendar', Calendar)
Vue.component('DatePicker', DatePicker)
// custom screen voor v-calendar werkt niet
// Vue.use(VCalendar, {
//   screens: {
//     desktop: '1340px',
//   },
// })


//Moment
Vue.filter('daysFromNow', function (value) {
  if (value) {
    return (moment(value.slice(0, 10)).diff(Date.now(), 'days') < 0) ? Math.abs(moment(value.slice(0, 10)).diff(Date.now(), 'days')) : 'Pending'
  }
})
Vue.filter('daysFromCreation', function (value) {
  if (value) {
    return Math.abs(moment(value.slice(0, 10)).diff(Date.now(), 'days'))
  }
})
Vue.filter('formatTime', function (value) {
  if (value) {
    const parts = value.split(':')
    return +parts[0] + ':' + +parts[1]
  } else {
    return 'unknown'
  }
})

Vue.filter('toCurrency', function (value) {
  return '€ ' + parseFloat(value).toFixed(2).replace('.', ',')
})

Vue.filter('dateFromNow', function (value) {
  if (value) {
    return moment(value).fromNow()
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY H:m')
  }
})

Vue.prototype.$moment = moment

import {Chart, registerables} from 'chart.js'

Chart.register(...registerables)

//Sweet Alert 2
import VueSweetalert2 from 'vue-sweetalert2'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

const swalOptions = {
  title:  i18n.t('swal.title'),
  text: i18n.t('swal.sub-title'),
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: i18n.t('swal.btn-ok'),
  cancelButtonText: i18n.t('swal.btn-cancel'),
  customClass: {
    confirmButton: 'btn btn-indigo',
    cancelButton: 'text-red-600 hover:underline ml-4',
  },
  buttonsStyling: false,
}

Vue.use(VueSweetalert2, swalOptions)


Vue.config.productionTip = false
Vue.mixin({methods: {route: window.route}})
Vue.use(plugin)
Vue.use(VueMeta)

Vue.prototype.can = function(value){
  if (this.$store.getters.can(value)) {
    return true
  }else{
    return false
  }
}

InertiaProgress.init()

const el = document.getElementById('app')

new Vue({
  i18n,
  store,
  metaInfo: {
    titleTemplate: title => (title ? `${title} - Vakantiebeheer.com` : 'Vakantiebeheer.com'),
  },
  render: function (h) {
    let data = JSON.parse(el.dataset.page)
    if (data['props']['auth']['owner']) {
      i18n.locale = data['props']['auth']['owner']['language'].toLowerCase()
      this.$store.commit('setPermissions', data['props']['auth']['owner']['permissions'])
    }

    return h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
      },
    },
    )
  },
}).$mount(el)
